/**
 * Direct API 호출용 베이스 클래스
 */

import { BaseProvider } from './BaseProvider'

export interface DirectProviderConfig {
  apiKey: string
  model: string
  apiUrl: string
  temperature?: number
  maxTokens?: number
}

export abstract class DirectProvider extends BaseProvider {
  type: 'direct' | 'proxy' = 'direct'
  
  protected apiKey: string
  protected model: string
  protected apiUrl: string
  protected temperature: number
  protected maxTokens: number
  
  constructor(config: DirectProviderConfig) {
    super()
    this.apiKey = config.apiKey
    this.model = config.model
    this.apiUrl = config.apiUrl
    this.temperature = config.temperature || 0.7
    this.maxTokens = config.maxTokens || 2000
  }
  
  /**
   * API 요청 본문 생성 (각 Provider별로 오버라이드 가능)
   */
  protected abstract buildRequestBody(systemPrompt: string, userPrompt: string): any
  
  /**
   * API 요청 헤더 생성 (각 Provider별로 오버라이드 가능)
   */
  protected abstract buildHeaders(): HeadersInit
  
  /**
   * API 응답에서 텍스트 추출 (각 Provider별로 오버라이드 가능)
   */
  protected abstract extractTextFromResponse(data: any): string
  
  /**
   * 공통 API 호출 구현
   */
  protected async callAPI(systemPrompt: string, userPrompt: string): Promise<string> {
    const requestBody = this.buildRequestBody(systemPrompt, userPrompt)
    
    const response = await fetch(this.apiUrl, {
      method: 'POST',
      headers: this.buildHeaders(),
      body: JSON.stringify(requestBody)
    })
    
    if (!response.ok) {
      const errorText = await response.text()
      throw new Error(`${this.name} API error: ${response.status} - ${errorText}`)
    }
    
    const data = await response.json()
    return this.extractTextFromResponse(data)
  }
}